/* Phones: the book finder form opens on tap. Desktop CSS shows the form always, so this only flips an attribute. */
(() => {
  const finder = document.querySelector('tandoori-book-finder');
  const button = finder && finder.querySelector('[data-finder-open]');
  if (!finder || !button) return;
  const set = (open) => {
    finder.toggleAttribute('data-open', open);
    button.setAttribute('aria-expanded', String(open));
  };
  button.addEventListener('click', () => set(!finder.hasAttribute('data-open')));
  // Shortcuts that point at the finder (#TandooriBookFinder) open it too, even when the hash is unchanged.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element && event.target.closest('a[href*="#TandooriBookFinder"]');
    if (link) set(true);
  });
  const fromHash = () => { if (location.hash === '#TandooriBookFinder') set(true); };
  window.addEventListener('hashchange', fromHash);
  fromHash();
})();
